<template>
  <div class="confirm-params-area">
    <ConfirmDialog :showDialog="showConfirmDialog"
                   :params="confirmDialogParams"
                   @backClick="showConfirmDialog = false"
                   @confirmClick="confirmDialogSubmit"></ConfirmDialog>
    <CustomCpn v-show="false"
               ref="customCpn"></CustomCpn>
    确认您需要的参数
    <div class="confirm-params-desc">
      我从您的问题中抽取了一些信息，包括类目、商品标题关键词、品牌等，我们用这些信息查询数据库，但我的识别可能有误，您可以修改，然后点击确认按钮继续
    </div>
    <div class="cat-params-area">
      <div style='display: flex;margin: 10px 0'>
        <label style="width: 110px">目标平台:</label>
        <span>{{currentPlat}}</span>
      </div>
      <div style='display: flex;position: relative;margin: 10px 0'>
        <span style="position: absolute; top: 25px;font-size: 12px; color: gray;width: 100px">最多选择3个一级类目，总共不能超过30个类目
        </span>
        <label style="width: 110px">目标类目:</label>
        <div style="display: flex; flex-direction: column; width: 80%">
          <div class="cat-block-title">
            <div v-html="catTitle"></div>
          </div>
          <div id="searchInput"
               style="display: flex;align-items: center;margin-bottom: 10px;">
            <input placeholder="搜索类目"
                   class="el-input__inner"
                   style="height: 28px;line-height: 28px;width: calc(80% - 40px);display: block"
                   id="catSearchInput"
                   v-model="searchValue"
                   @keyup.enter.stop="searchChange" />
            <button type="button"
                    class="el-button el-button--primary el-button--mini"
                    style="font-size: 16px; width: 30px;margin-top: 0px;padding: 5px;width: 28px;height: 28px;border-radius: 0;opacity: .9;"
                    id="catSearchBtn"
                    @click="searchChange">
              <i class="el-icon-search"></i>
            </button>
            <i class="el-icon-question cat-question-icon"></i>
          </div>
          <div id="filterCatTree"
               class="ztree"
               style="height: 300px;overflow-y: scroll;width: 80%;"></div>
          <div id="catTree"
               class="ztree"
               style="height: 300px;overflow-y: scroll;width: 80%;display: none"></div>
          <div id="searchCatTree"
               class="ztree"
               style="height: 300px;overflow-y: scroll;width: 80%;display:none"></div>
          <div class="switchCatTree">
            找不到想要的类目?<span class="underline"
                  @click="contactClick">联系我们</span>或从<span class="underline"
                  @click="switchCatTree('catTree')">全部类目</span>中筛选
          </div>
          <div class="allCatTreeText"
               style="display: none">
            <div>
              还是不确定类目范围是否准确？
              <span class="underline"
                    @click="contactClick">联系我们</span>
            </div>
            <el-tooltip class="item"
                        effect="dark"
                        content="如您在全部类目中增减类目，类目修改不会同步至仅预选类目中"
                        placement="top-start">
              <div style="margin-right: 100px;
    text-decoration: underline;
    cursor: pointer;
    font-weight: 400;"
                   @click="backToFilterTree">返回仅预选类目</div>
            </el-tooltip>

          </div>
        </div>

      </div>

      <div style='display: flex;align-items: center;margin: 10px 0;position: relative;'
           id="filter-panel-title-area"
           ref="inputField">
        <label style="width: 110px">商品标题关键词:</label>
        <input class="title-input"
               :class="{is_error: titleErrorType != -1 }"
               type="input"
               placeholder="例如输入“益生菌”则筛选类目下标题含“益生菌”的商品数据"
               style="height: 26px; line-height: 26px;border-radius: 4px;border: 1px solid #DCDFE6; width: 70%; color: #3f3f3f;padding: 0 10px;"
               v-model="title"
               @focus="focusTitle"
               @blur="blurTitle" />

        <el-popover placement="top"
                    width="360"
                    trigger="manual"
                    ref="popover"
                    v-model="showKeyInspect"
                    popper-class="keyWordPopover">
          <div class="keyWordPopover_content">
            <div>
              <div style="display: flex; justify-content: flex-end;font-size: 16px; cursor: pointer"
                   @click="showKeyInspect = false">
                <i class="el-icon-error"></i>
              </div>
              <div style="font-size:13px"
                   v-html="parse_word_title"></div>
              <div style="font-size:13px"
                   v-if="parse_word_subtitle">{{parse_word_subtitle}}</div>
              <div style="font-size:14px;color:#3a63f3;padding:5px 0"
                   v-html="parse_word"></div>
              <div style="font-size:13px">确认逻辑无误再提交搜索，数据更精准哦</div>
            </div>
          </div>

          <el-button type="text"
                     slot="reference"
                     style="margin-left: 5px"
                     @click="keyWordInspect">检查</el-button>
        </el-popover>
      </div>
      <div class="title-sub-desc">
        <span style="font-weight: bolder;margin-right: 4px">类目筛选太宽泛?</span>
        <span style="font-weight: 400">使用and/or/not规则继续精准圈选商品范围</span>
        <el-tooltip placement="top-start">
          <div slot="content">
            <p>
              支持使用“and”、“or”、“not”的筛选条件，
              <span style="color: #ffff00">与汉字用空格隔开</span>
              <span>。</span>
            </p>
            <p>如： “小米 and 华为”表示商品标题既包含“小米”又包含“华为”</p>
            <p>“小米 or 华为 ” 表示商品标题“小米”“华为”至少包含其一</p>
            <p>“小米 not 华为” 表示商品标题包含“小米”且不包含“华为”</p>
          </div>
          <i class="el-icon-question"
             style="margin-right:5px"></i>
        </el-tooltip>
      </div>
      <div style='display: flex;align-items: center;margin: 10px 0'>
        <label style="width: 110px">时间范围:</label>
        <div class="cat-seletor-time">
          <MonthPickerCpn :minDate="'2022-01'"
                          :maxDate="maxDate"
                          :dateTime="catTime"
                          @change="changeTime" />
        </div>
      </div>

      <div style='display: flex;margin: 10px 0'
           ref="brandField">
        <label style="width: 110px">分析品牌:</label>
        <input class="brand-input"
               :class="{is_error: brandErrorType != -1 }"
               type="input"
               placeholder=""
               style="height: 26px; line-height: 26px;border-radius: 4px;border: 1px solid #DCDFE6; width: 70%; color: #3f3f3f;padding: 0 10px"
               v-model="brand"
               @focus="focusBrand"
               @blur="blurBrand" />
        <el-popover placement="top"
                    width="360"
                    trigger="manual"
                    ref="popover"
                    v-model="showBrandInspect"
                    popper-class="keyWordPopover">
          <div class="keyWordPopover_content">
            <div>
              <div style="display: flex; justify-content: flex-end;font-size: 16px; cursor: pointer"
                   @click="showBrandInspect = false">
                <i class="el-icon-error"></i>
              </div>
              <div style="font-size:13px"
                   v-html="parse_brand_title"></div>
              <div style="font-size:13px"
                   v-if="parse_brand_subtitle">{{parse_brand_subtitle}}</div>
              <div style="font-size:14px;color:#3a63f3;padding:5px 0"
                   v-html="parse_brand"></div>
              <div style="font-size:13px">确认逻辑无误再提交搜索，数据更精准哦</div>
            </div>
          </div>

          <el-button type="text"
                     slot="reference"
                     style="margin-left: 5px"
                     @click="brandInspect">检查</el-button>
        </el-popover>
      </div>
      <div style="display: flex; flex-direction: row-reverse;margin-right: 10px;margin-top: 10px">
        <div class="el-button el-button--primary el-button--mini custom-confirm"
             style="font-size: 16px"
             :class="{is_loading: confirmLoading}"
             @click="confirmClick">确认继续生成答案</div>
        <img :src="shouzhi"
             class="shouzhi-ani"
             style="width: 34px;margin-right: 10px" />
      </div>
    </div>
  </div>
</template>


<script>
import CustomCpn from '../CustomCpn.vue'
import { overseaPlatMap } from '../cat-plat/platOptions'
import { getPyoutParser } from '@/api/public'
// import { cats } from '../cat-plat/catString'

import MonthPickerCpn from '@/components/monthPickerCpn/MonthPickerCpn.vue'
import ConfirmDialog from './ConfirmDialogCpn.vue'
export default {
  name: 'FilterPanel',
  components: {
    CustomCpn,
    MonthPickerCpn,
    ConfirmDialog,
  },
  data() {
    this.catTreeObj = {}
    this.filterCatTreeObj = {}
    const maxDate = this.getTwoMonthsAgo()
    return {
      parse_word: '',
      parse_word_title: '',
      parse_word_subtitle: null,
      parse_brand: '',
      parse_brand_title: '',
      parse_brand_subtitle: null,
      setting: {
        treeId: 'id',
        data: {
          key: {
            name: 'label',
            name_old_name: 'labelOldNew',
            title: '',
          },
          simpleData: {
            enable: true,
            idKey: 'id',
            pIdKey: 'pId',
            rootPId: 0,
          },
        },
        view: {
          showIcon: false,
          //   showLine: false,
          fontCss: this.zTreefontCss,
          nodeClasses: this.zTreeNodeClasses,
          addHoverDom: function (treeId, treeNode) {
            let stack = new Error().stack
            if ($(`.cattree-tooltip-${treeId}`).length > 0) return
            if (stack.indexOf('onHoverOverNode') == -1) return
            if (treeNode.reason) {
              const idStr = treeNode.tId + '_a'
              let targetElement = document.getElementById(idStr)
              // targetElement.css({
              //   position: 'relative',
              // })
              const rect = targetElement.getBoundingClientRect()
              const scrollX = window.scrollX || window.pageXOffset
              const scrollY = window.scrollY || window.pageYOffset
              const popup = document.createElement('div')
              popup.id = `cattree-tooltip-${treeNode.id}`
              popup.innerHTML = `<div role="tooltip"
             aria-hidden="true"
             class="el-tooltip__popper is-dark cattree-tooltip-${treeId} cattree-reason"
             x-placement="right"
             style="position:absolute;left:110%;top:-50%;white-space: wrap;width: 545px">
             ${treeNode.reason}
             <div x-arrow="" class="tip_popper__arrow" style="top: 11px;left: -6px;"></div>
             </div>`
              Object.assign(popup.style, {
                position: 'fixed',
                left: `${rect.right + scrollX + 5}px`, // 右侧5px间距
                top: `${rect.top + scrollY}px`,
                zIndex: '1000',
              })
              // 将弹框添加到页面
              document.body.appendChild(popup)
              $(targetElement).one('mouseleave', function () {
                $(`.cattree-tooltip-${treeId}`).remove()
              })
              // aObj.append(editStr)
              // aObj.one('mouseleave', function () {
              //   $(`.cattree-tooltip-${treeId}`).remove()
              // })
            }
            var aObj = $('#' + treeNode.tId + '_a')
            aObj.css({
              position: 'relative',
            })
            var editStr = `<div role="tooltip"
             id="cattree-tooltip-${treeNode.id}"
             aria-hidden="true"
             class="el-tooltip__popper is-dark cattree-tooltip-${treeId}"
             x-placement="right"
             style="position:absolute;left:110%;top:-50%;white-space: nowrap;">
             ${treeNode.cat_tip}
             <div x-arrow="" class="tip_popper__arrow" style="top: 11px;left: -6px;"></div>
             </div>`
            if (treeNode.cat_tip) {
              aObj.append(editStr)
              aObj.one('mouseleave', function () {
                $(`.cattree-tooltip-${treeId}`).remove()
              })
            }
          },
          removeHoverDom: function (treeId, treeNode) {
            $(`.cattree-tooltip-${treeId}`).remove()
          },
          nameIsHTML: true,
          showTitle: false,
        },
        check: {
          enable: true,
          chkStyle: 'checkbox',
          radioType: 'all',
          autoCheckTrigger: false,
          chkDisabledInherit: false,
          nocheckInherit: false,
          chkboxType: { Y: 'ps', N: 'ps' },
        },
        callback: {
          onCheck: this.zTreeOnCheck,
          beforeCheck: this.treeBeforeCheck,
        },
      },
      searchSetting: {
        treeId: 'id',
        async: {
          enable: false,
          url: '',
          autoParam: ['id'],
        },
        data: {
          key: {
            name: 'label',
            name_old_name: 'labelOldNew',
          },
          simpleData: {
            enable: true,
            idKey: 'id',
            pIdKey: 'pId',
            rootPId: 0,
          },
        },
        view: {
          showIcon: false,
          //   showLine: false,
          fontCss: this.zTreeSearchfontCss,
          nodeClasses: this.zTreeSearchNodeClasses,
          addHoverDom: function (treeId, treeNode) {
            var aObj = $('#' + treeNode.tId + '_a')
            let stack = new Error().stack
            if (stack.indexOf('onHoverOverNode') == -1) return
            if ($(`.cattree-tooltip-${treeId}`).length > 0) return
            aObj.css({
              position: 'relative',
            })
            var editStr = `<div role="tooltip"
             id="cattree-tooltip-${treeNode.id}"
             aria-hidden="true"
             class="el-tooltip__popper is-dark cattree-tooltip-${treeId}"
             x-placement="right"
             style="position:absolute;left:110%;top:-50%;white-space: nowrap;">
             ${treeNode.cat_tip}
             <div x-arrow="" class="tip_popper__arrow" style="top: 11px;"></div>
             </div>`
            if (treeNode.cat_tip) {
              aObj.append(editStr)
              aObj.one('mouseleave', function () {
                $(`.cattree-tooltip-${treeId}`).remove()
              })
            }
          },
          removeHoverDom: function (treeId, treeNode) {
            $(`.cattree-tooltip-${treeId}`).remove()
          },
        },
        check: {
          enable: true,
          chkStyle: 'checkbox',
          radioType: 'all',
          autoCheckTrigger: false,
          chkDisabledInherit: false,
          nocheckInherit: false,
          chkboxType: { Y: 'ps', N: 'ps' },
        },
        callback: {
          onClick: this.zTreeSearchOnClick,
          onCheck: this.treeSearchOnCheck,
          beforeCheck: this.treeSearchBeforeCheck,
        },
      },
      zNodes: [],
      filterNodes: [],
      shouzhi: require('../../assets/youshouzhi.svg'),
      maxDate: maxDate,
      treeSelectedData: [],
      title: '',
      brand: '',
      currentPlat: '',
      searchValue: '',
      options: {
        searchShowParent: true,
        searchPlaceholder: '按enter检索',
        searchKeys: null,
      },
      catTitle: '',
      showKeyInspect: false,
      showBrandInspect: false,
      isFilterCatTree: true,
      titleErrorType: -1,
      brandErrorType: -1,
      confirmLoading: false,
      showConfirmDialog: false,
      confirmDialogParams: {
        timeRange: '',
        cats: [],
        parse_word: '',
        parse_word_title: '',
        parse_word_subtitle: null,
        parse_brand: '',
        parse_brand_title: '',
        parse_brand_subtitle: null,
        titleErrorType: -1,
        brandErrorType: -1,
        title: '',
        brand: '',
      },
    }
  },
  props: {
    params: {
      default: {
        brand: '',
        title: '',
        plat: '',
      },
    },
    catTime: {
      default: null,
    },
  },
  computed: {},
  methods: {
    backToFilterTree() {
      this.initPanel()
    },
    handleDocumentClick() {
      this.showKeyInspect = false
    },
    focusTitle() {
      const inputRect = this.$refs.inputField.getBoundingClientRect()
      this.$emit('focusTitle', { inputRect })
      this.showKeyInspect = false
      this.showBrandInspect = false
    },
    blurTitle() {
      this.$emit('blurTitle')
      this.keyWordInspect()
    },
    focusBrand() {
      const inputRect = this.$refs.brandField.getBoundingClientRect()
      this.$emit('focusBrand', { inputRect })
      this.showBrandInspect = false
      this.showKeyInspect = false
    },
    blurBrand() {
      this.$emit('blurBrand')
      this.brandInspect()
    },
    keyWordInspect() {
      if (this.title) {
        this.keyWordBlur()
        setTimeout(() => {
          this.showKeyInspect = true
        }, 300)
      } else {
        this.parse_word = ''
        this.parse_word_title = ''
        this.parse_word_subtitle = null
        this.titleErrorType = -1
        // this.$message({
        //   message: '请输入帖子关键词！',
        //   type: 'warning',
        // })
      }
    },
    keyWordBlur() {
      this.showBrandInspect = false
      if (this.title) {
        getPyoutParser({ word: this.title, plat: '' })
          .then((res) => {
            if (res.status == 'ok') {
              const { result } = res
              let word = this.title
              if (result.state == 'ok') {
                this.titleErrorType = -1
                this.parse_word_title =
                  '系统会按照以下格式来理解您输入的关键词表达式'
                this.parse_word = result.parse_word
              } else if (result.state == 'error') {
                this.titleErrorType = result.error_type
                if (result.error_type == 0) {
                  this.parse_word_title = '您的关键词表达式有误！'
                  this.parse_word_subtitle = null
                  let textArr = word.split('')
                  textArr[[result.parse_word[0]]] = `<span style="color:red">${
                    textArr[result.parse_word[0]]
                  }</span>`
                  this.parse_word = textArr.join('')
                } else if (result.error_type == 1) {
                  this.parse_word_title =
                    '关键词检索<span style="color: red">不支持中文顿号/逗号/引号</span>'
                  this.parse_word_subtitle =
                    '您是否想以and或or的关系筛选多个关键词？'
                  let textArr = word.split('')
                  textArr[[result.parse_word[0]]] = `<span style="color:red">${
                    textArr[result.parse_word[0]]
                  }</span>`
                  this.parse_word = textArr.join('')
                } else if (result.error_type == 2) {
                  this.parse_word_title =
                    '<span style="color: red">and/or/not前后需要加空格</span>，才能生效哦！请修改'
                  this.parse_word_subtitle = null
                  let parseArr = result.parse_word
                  word =
                    word.substring(0, parseArr[0]) +
                    `<span style="color:red">${word.substring(
                      parseArr[0],
                      parseArr[1]
                    )}</span>` +
                    word.substring(parseArr[1], word.length)
                  this.parse_word = word
                }
              }
            }
          })
          .catch((err) => {
            this.titleErrorType = -1
            this.parse_word = this.title
          })
      }
    },
    brandInspect() {
      this.showKeyInspect = false
      if (this.brand) {
        this.showBrandBlur()
        setTimeout(() => {
          this.showBrandInspect = true
        }, 300)
      } else {
        this.parse_brand = ''
        this.parse_brand_title = ''
        this.parse_brand_subtitle = null
        this.brandErrorType = -1
      }
    },
    showBrandBlur() {
      if (this.brand) {
        getPyoutParser({ word: this.brand, plat: '' })
          .then((res) => {
            if (res.status == 'ok') {
              const { result } = res
              let word = this.brand
              if (result.state == 'ok') {
                this.brandErrorType = -1
                this.parse_brand_title =
                  '系统会按照以下格式来理解您输入的关键词表达式'
                this.parse_brand = result.parse_word
              } else if (result.state == 'error') {
                this.brandErrorType = result.error_type
                if (result.error_type == 0) {
                  this.parse_brand_title = '您的关键词表达式有误！'
                  this.parse_brand_subtitle = null
                  let textArr = word.split('')
                  textArr[[result.parse_word[0]]] = `<span style="color:red">${
                    textArr[result.parse_word[0]]
                  }</span>`
                  this.parse_brand = textArr.join('')
                } else if (result.error_type == 1) {
                  this.parse_brand_title =
                    '关键词检索<span style="color: red">不支持中文顿号/逗号/引号</span>'
                  this.parse_brand_subtitle =
                    '您是否想以and或or的关系筛选多个关键词？'
                  let textArr = word.split('')
                  textArr[[result.parse_word[0]]] = `<span style="color:red">${
                    textArr[result.parse_word[0]]
                  }</span>`
                  this.parse_brand = textArr.join('')
                } else if (result.error_type == 2) {
                  this.parse_brand_title =
                    '<span style="color: red">and/or/not前后需要加空格</span>，才能生效哦！请修改'
                  this.parse_brand_subtitle = null
                  let parseArr = result.parse_word
                  word =
                    word.substring(0, parseArr[0]) +
                    `<span style="color:red">${word.substring(
                      parseArr[0],
                      parseArr[1]
                    )}</span>` +
                    word.substring(parseArr[1], word.length)
                  this.parse_brand = word
                }
              }
            }
          })
          .catch((err) => {
            this.brandErrorType = -1
            this.parse_brand = this.brand
          })
      }
    },
    switchCatTree() {
      this.isFilterCatTree = false
      // 1. 隐藏filter类目树
      $('.switchCatTree').hide()
      $('#filterCatTree').hide()
      $('.cat-block-title').hide()
      // 2. 初始化类目树
      this.initNormalCatTree()
      $('#searchInput').show()
      $('#catTree').show()
      $('#searchCatTree').hide()
      $('.allCatTreeText').show()
    },
    initNormalCatTree() {
      const plat = this.params.plat
      let platCats, platChildrenList
      let isOverseaPlat = this.isOverseaPlat(plat)
      let startWorker
      if (!isOverseaPlat) {
        if (plat.indexOf('taobao') > -1 || plat.indexOf('tmall') > -1) {
          platCats = window['cache_cat'].result.bigCategory
          platChildrenList = window['cache_cat'].result.childrenList
        } else if (plat == 'jd' || plat == '京东') {
          platCats = window['cache_cat_jd'].result.bigCategory
          platChildrenList = window['cache_cat_jd'].result.childrenList
        } else if (plat == 'douyin' || plat == '抖音') {
          platCats = window['cache_douyin_cats'].result.bigCategory
          platChildrenList = window['cache_douyin_cats'].result.childrenList
        } else {
          platCats = window['cache_cat'].result.bigCategory
          platChildrenList = window['cache_cat'].result.childrenList
        }
        startWorker = this.$refs.customCpn.startWorker
      } else {
        const plat_value = overseaPlatMap[plat]
        if (plat_value) {
          platCats =
            window['cache_cat_oversea_' + plat_value].result.bigCategory
          platChildrenList =
            window['cache_cat_oversea_' + plat_value].result.childrenList
          startWorker = this.$refs.customCpn.startOverseaWorker
        } else {
          platCats = window['cache_cat'].result.bigCategory
          platChildrenList = window['cache_cat'].result.childrenList
          startWorker = this.$refs.customCpn.startWorker
        }
      }
      startWorker(platCats, platChildrenList, 'all', plat).then((res) => {
        this.zNodes = res
        this.initCatTree()

        this.checkDefaultCats(
          this.params.cats
            .filter((item, index) => {
              return this.params.selected[index] == 'Y'
            })
            .map((item) => {
              return {
                ...item,
                cat_id: item.cat_id[item.cat_id.length - 1],
              }
            })
        )
      })
    },
    contactClick() {
      this.$emit('contact-event')
    },
    initPanel() {
      this.isFilterCatTree = true
      let platCats, platChildrenList
      const plat = this.params.plat
      let isOverseaPlat = this.isOverseaPlat(this.params.plat)
      let startWorker
      if (!isOverseaPlat) {
        if (
          (plat.indexOf('taobao') > -1 || plat.indexOf('tmall') > -1) &&
          window['cache_cat']
        ) {
          platCats = window['cache_cat'].result.bigCategory
          platChildrenList = window['cache_cat'].result.childrenList
        } else if ((plat == 'jd' || plat == '京东') && window['cache_cat_jd']) {
          platCats = window['cache_cat_jd'].result.bigCategory
          platChildrenList = window['cache_cat_jd'].result.childrenList
        } else if (
          (plat == 'douyin' || plat == '抖音') &&
          window['cache_douyin_cats']
        ) {
          platCats = window['cache_douyin_cats'].result.bigCategory
          platChildrenList = window['cache_douyin_cats'].result.childrenList
        } else if (window['cache_cat']) {
          platCats = window['cache_cat'].result.bigCategory
          platChildrenList = window['cache_cat'].result.childrenList
        } else {
          platCats = []
          platChildrenList = {}
        }
        startWorker = this.$refs.customCpn.startWorker
      } else {
        const plat_value = overseaPlatMap[plat]
        if (plat_value && window['cache_cat_oversea_' + plat_value]) {
          platCats =
            window['cache_cat_oversea_' + plat_value].result.bigCategory
          platChildrenList =
            window['cache_cat_oversea_' + plat_value].result.childrenList
          startWorker = this.$refs.customCpn.startOverseaWorker
        } else if (window['cache_cat']) {
          platCats = window['cache_cat'].result.bigCategory
          platChildrenList = window['cache_cat'].result.childrenList
          startWorker = this.$refs.customCpn.startWorker
        } else {
          platCats = []
          platChildrenList = {}
          startWorker = this.$refs.customCpn.startWorker
        }
      }
      this.$nextTick(() => {
        setTimeout(() => {
          this.addQuestionPoP()
        }, 500)
      })
      startWorker(platCats, platChildrenList, 'all', plat).then((res) => {
        this.zNodes = res
        let obj = $.fn.zTree.init($('#catTree'), this.setting, this.zNodes)
        this.catTreeObj = obj
        if (this.params.cats.length > 0) {
          const cats = this.params.cats.map((item, index) => {
            return {
              ...item,
              reason: this.params.reason[index],
              selected: this.params.selected[index],
            }
          })
          this.catTitle = this.params.cat_block_title
          $('#searchInput').hide()
          $('#catTree').hide()
          $('#searchCatTree').hide()
          $('.allCatTreeText').hide()
          $('.switchCatTree').show()
          $('#filterCatTree').show()
          $('.cat-block-title').show()
          // 1. 整体的大类目确定
          const filterBigCats = cats.map((item) => item.cat_id[0])
          const bigCats = [...new Set(filterBigCats)]
          // 2. 选中类目确定
          const filterCheckedCats = cats
            .filter((item) => item.selected == 'Y')
            .map((item) => item.cat_id[item.cat_id.length - 1])
          // 3. 初始化filter类目树
          startWorker(bigCats, platChildrenList, 'all', plat).then((res) => {
            this.filterNodes = res
            this.initFilterCatTree()
            // 4. 筛选过滤 后台传过来的类目数组
            const filterCatsId = cats.map(
              (item) => item.cat_id[item.cat_id.length - 1]
            )

            let filterNodeList = this.filterCatTreeObj.getNodesByFilter(
              function (node) {
                return filterCatsId.includes(node.id)
              }
            ) //通过关键字模糊搜索
            let datasMap = {}
            let _this = this
            $(filterNodeList).each(function (index, item) {
              datasMap[item['id']] = item
              const catItem = cats.find(
                (ele) => ele.cat_id[ele.cat_id.length - 1] == item.id
              )
              if (catItem) {
                item.reason = catItem.reason
              }
            })
            $(filterNodeList).each(function (index, node) {
              _this.loadParents(node, datasMap)
            })
            this.filterNodes = _.values(datasMap)
            let obj = $.fn.zTree.init(
              $('#filterCatTree'),
              this.setting,
              this.filterNodes
            )

            this.filterCatTreeObj = obj
            this.checkFilterCats(filterCheckedCats)
            this.checkDefaultCats(filterCheckedCats)
          })
        } else {
          $('#searchInput').show()
          $('#catTree').show()
          $('#searchCatTree').hide()
          $('.allCatTreeText').show()
          $('.switchCatTree').hide()
          $('#filterCatTree').hide()
          $('.cat-block-title').hide()
        }
      })
    },
    checkFilterCats(cats) {
      const defaultNodes = []
      cats.forEach((cat_id) => {
        const node = this.filterCatTreeObj.getNodeByParam('id', cat_id)
        defaultNodes.unshift(node)
        this.filterCatTreeObj.checkAllNodes(false)
        defaultNodes.forEach((item, index) => {
          this.topCheckedNodes(null, 'filterCatTree', item)
        })
        cats.forEach((cat_id) => {
          const node = this.filterCatTreeObj.getNodeByParam('id', cat_id)
          if (node) {
            this.filterCatTreeObj.checkNode(node, true, true)
            this.filterCatTreeObj.selectNode(node, true, false)
            this.filterCatTreeObj.expandNode(node, false)
          }
        })
        this.treeSelectedData = []
        let ignoreIds = []
        this.filterCatTreeObj.getCheckedNodes().forEach((item) => {
          const { path, cid_path } = this.computeNodePath(item)
          const catInfo = {
            cat_name: item.label,
            cat_id: item.id,
            is_parent: item.is_parent,
            path,
            cid_path,
          }
          if (cats.find((item) => item == catInfo.cat_id)) {
            this.treeSelectedData.push(catInfo)
          }
          // 该节点被全选且父节点未被选中,则子节点id不传入
          if (item.check_Child_State == 2 && ignoreIds.indexOf(item.id) == -1) {
            // this.treeSelectedData.push(catInfo)
            ignoreIds.push(...this.getChdNodesIds(item))
          } // 父节点不是全选,子节点没有children
          else if (
            item.check_Child_State == -1 &&
            ignoreIds.indexOf(item.id) == -1
          ) {
            // this.treeSelectedData.push(catInfo)
          }
        })
      })
    },
    checkDefaultCats(cats) {
      const defaultNodes = []
      cats.forEach((item) => {
        const node = this.catTreeObj.getNodeByParam(
          'id',
          item.cat_id ? item.cat_id : item
        )
        defaultNodes.unshift(node)
        this.catTreeObj.checkAllNodes(false)
        defaultNodes.forEach((item, index) => {
          this.topCheckedNodes(null, 'catTree', item)
        })
        cats.forEach((item) => {
          const node = this.catTreeObj.getNodeByParam(
            'id',
            item.cat_id ? item.cat_id : item
          )
          if (node) {
            this.catTreeObj.checkNode(node, true, true)
            this.catTreeObj.selectNode(node, true, false)
          }
        })
        this.treeSelectedData = []
        let ignoreIds = []
        this.catTreeObj.getCheckedNodes().forEach((item) => {
          const { path, cid_path } = this.computeNodePath(item)
          const catInfo = {
            cat_name: item.label,
            cat_id: item.id,
            is_parent: item.is_parent,
            path,
            cid_path,
          }
          // 该节点被全选且父节点未被选中,则子节点id不传入
          if (item.check_Child_State == 2 && ignoreIds.indexOf(item.id) == -1) {
            this.treeSelectedData.push(catInfo)
            ignoreIds.push(...this.getChdNodesIds(item))
          } // 父节点不是全选,子节点没有children
          else if (
            item.check_Child_State == -1 &&
            ignoreIds.indexOf(item.id) == -1
          ) {
            this.treeSelectedData.push(catInfo)
          }
        })
      })
    },
    // 判断是否为oversea 平台.
    isOverseaPlat(plat) {
      return ['亚马逊', '虾皮', '来赞达'].some((brand) => plat.includes(brand))
    },
    initFilterCatTree() {
      let obj = $.fn.zTree.init(
        $('#filterCatTree'),
        this.setting,
        this.filterNodes
      )
      this.filterCatTreeObj = obj
    },
    initCatTree() {
      let obj = $.fn.zTree.init($('#catTree'), this.setting, this.zNodes)
      this.catTreeObj = obj
    },
    getTwoMonthsAgo() {
      const today = new Date()
      let year = today.getFullYear()
      let month = today.getMonth() // getMonth()返回0-11之间的数，0代表一月

      // 减去两个月
      month -= 2

      // 如果月份小于0，说明跨年份，需要调整年份和月份
      if (month < 0) {
        month += 12
        year -= 1
      }

      // 将月份和年份格式化为 YYYY-MM 的形式
      const formattedMonth = month < 9 ? `0${month + 1}` : `${month + 1}`
      return `${year}-${formattedMonth}`
    },
    changeTime(dateTime) {
      this.$emit('change', dateTime)
    },
    confirmClick() {
      this.confirmLoading = true
      setTimeout(() => {
        this.showKeyInspect = false
        this.showBrandInspect = false
      }, 400)

      setTimeout(() => {
        if (this.hasCheckedValues()) {
          this.confirmLoading = false
          if (this.titleErrorType != -1 || this.brandErrorType != -1) {
            this.confirmDialogParams = {
              timeRange: this.catTime,
              cats: this.treeSelectedData,
              parse_word: this.parse_word,
              parse_word_title: this.parse_word_title,
              parse_word_subtitle: this.parse_word_subtitle,
              parse_brand: this.parse_brand,
              parse_brand_title: this.parse_brand_title,
              parse_brand_subtitle: this.parse_brand_subtitle,
              titleErrorType: this.titleErrorType,
              brandErrorType: this.brandErrorType,
              title: this.title,
              brand: this.brand,
            }
            this.showConfirmDialog = true
          } else {
            this.$emit('confirm-event', {
              brand: this.brand,
              title: this.title,
              cats: this.treeSelectedData,
              plat: this.params.plat,
              entity: this.params.entity,
            })
          }
        }
      }, 1000)
      return
    },
    confirmDialogSubmit() {
      this.showConfirmDialog = false
      this.$emit('confirm-event', {
        brand: this.brand,
        title: this.title,
        cats: this.treeSelectedData,
        plat: this.params.plat,
        entity: this.params.entity,
      })
    },
    hasCheckedValues() {
      if (this.title) {
        if (this.title !== this.params.title && !this.parse_word) {
          return false
        }
      }
      if (this.brand) {
        if (this.brand !== this.params.brand && !this.parse_brand) {
          return false
        }
      }
      if (this.title === '' && this.brand === '') {
        return true
      }
      return true
    },
    zTreeOnCheck(event, treeId, treeNode) {
      this.treeSelectedData = []
      let ignoreIds = []
      const catObj = this.catTreeObj.getNodeByParam('id', treeNode.id)
      this.catTreeObj.checkNode(catObj, treeNode.checked, true)
      this.catTreeObj.getCheckedNodes().forEach((item) => {
        const { path, cid_path } = this.computeNodePath(item)
        const catInfo = {
          cat_name: item.label,
          cat_id: item.id,
          is_parent: item.is_parent,
          path,
          cid_path,
        }
        // 该节点被全选且父节点未被选中,则子节点id不传入
        if (item.check_Child_State == 2 && ignoreIds.indexOf(item.id) == -1) {
          this.treeSelectedData.push(catInfo)
          ignoreIds.push(...this.getChdNodesIds(item))
        } // 父节点不是全选,子节点没有children
        else if (
          item.check_Child_State == -1 &&
          ignoreIds.indexOf(item.id) == -1
        ) {
          this.treeSelectedData.push(catInfo)
        }
      })
      this.topCheckedNodes(event, treeId, treeNode)
      this.catTreeObj.selectNode(treeNode, true, false)
    },
    treeBeforeCheck(treeId, treeNode) {
      // 限制用户选择少于30个类目
      if (!this.limitCat_30(treeNode)) {
        return false
      }
    },
    limitCat_30(node) {
      // 用户取消已选择的类目,允许继续执行
      if (
        this.treeSelectedData.find((ele) => ele.id == node.id) ||
        node.check_Child_State == 1
      ) {
        return true
      }
      // 选择类目超过30个,禁止操作并报错
      if (this.treeSelectedData.length >= 30) {
        this.$message.warning('选择类目超过30个,请重新选择!')
        return false
      } else {
        return true
      }
    },
    computeNodePath(node) {
      const path = []
      const cid_path = []
      const pathes = node.getPath()
      pathes.forEach((item) => {
        path.push(item.label)
        cid_path.push(item.id)
      })
      return { path, cid_path }
    },
    getChdNodesIds(nodes) {
      const ids = []
      if (nodes.children && nodes.children.length > 0) {
        nodes.children.forEach((item) => {
          ids.push(item.id)
          if (item.children && item.children.length > 0) {
            ids.push(...this.getChdNodesIds(item))
          }
        })
      }
      return ids
    },
    /**
     * 置顶已选中的类目
     */
    topCheckedNodes(event, treeId, treeNode) {
      if (treeNode) {
        treeNode.getPath().forEach((node) => {
          this.topNode(event, treeId, node)
        })
      }
    },
    /**
     * ! 在同级节点中置顶
     * @param {Object} event
     * @param {String} treeId
     * @param {Object} treeNode
     */
    topNode(event, treeId, treeNode) {
      const catTreeObj = $.fn.zTree.getZTreeObj(treeId)
      if (!treeNode.isFirstNode) {
        // 如果本身不是置顶节点,执行置顶操作
        let currentNodes = []
        const parentNode = treeNode.getParentNode()
        if (parentNode) {
          // 非根节点置顶
          currentNodes = catTreeObj.getNodesByFilter((node) => {
            if (node.getParentNode()) {
              return node.getParentNode().id == parentNode.id
            }
          })
          catTreeObj.moveNode(currentNodes[0], treeNode, 'prev')
        } else {
          // 根节点前置
          currentNodes = catTreeObj.getNodes()
          catTreeObj.moveNode(currentNodes[0], treeNode, 'prev')
        }
      }
    },
    addQuestionPoP() {
      const pop = $('#question-pop')
      $('.cat-question-icon').hover(
        function () {
          pop
            .css({
              top: $(this).offset().top + $(this).outerHeight() - 10,
              left: $(this).offset().left,
            })
            .show()
          $(
            '#question-pop-text'
          )[0].innerText = `在这一步选择您关注的商品类目，类目划分与电商平台一致。
如果不熟悉电商平台的类目构成，可以在输入框中用关键词搜索类目，如“冲饮”“美容护肤”等。
如关注的市场或商品十分精确（如“泡茶水”），可以先找到所属的类目，再使用下方的关键词定位细分市场。
以“泡茶水”为例，可选择“咖啡/麦片/冲饮”类目，并在下方商品标题关键词中输入“泡茶水”。`
        },
        function () {
          pop.hide()
        }
      )
      $('.title-question-icon').hover(
        function () {
          pop
            .css({
              top: $(this).offset().top + $(this).outerHeight() - 10,
              left: $(this).offset().left,
            })
            .show()
          $(
            '#question-pop-text'
          )[0].innerText = `在这一步，镜界将使用您输入的关键词，在电商平台的商品标题中做匹配。如搜索“即饮咖啡”，将匹配标题中含有“即饮咖啡”这个词的商品。
商品标题支持逻辑组合搜索，使用“and”、“or”、“not”的筛选条件， 与汉字用空格隔开。
如： “小米 and 华为”表示商品标题既包含“小米”又包含“华为”
“小米 or 华为 ” 表示商品标题“小米”“华为”至少包含其一
“小米 not 华为” 表示商品标题包含“小米”且不包含“华为”`
        },
        function () {
          pop.hide()
        }
      )
    },
    searchChange() {
      const value = this.searchValue
      if (value.trim() !== '') {
        $('#catTree').hide()
        $('#searchCatTree').show()
        this.doSearch(value)
      } else {
        $('#catTree').show()
        $('#searchCatTree').hide()
        this.treeSelectedData.forEach((item) => {
          const node = this.catTreeObj.getNodeByParam('id', item.cat_id)
          this.catTreeObj.selectNode(node, true, false)
        })
      }
    },
    doSearch(searchWord) {
      let _this = this
      /*异步执行低频率执行解决性能问题*/
      if (_this.searchTime) {
        clearTimeout(_this.searchTime)
      }
      _this.searchTime = setTimeout(function () {
        let serverSearch =
          _this.options.serverSearch ||
          function () {
            return new Promise(function (resolve, reject) {
              resolve(null)
            })
          }
        serverSearch(searchWord).then(function (serverSearchData) {
          let searchcatTreeObj = _this.catTreeObj
          let nodeList = searchcatTreeObj.getNodesByFilter(function (node) {
            return _this.ifHit(node, searchWord, serverSearchData)
          }) //通过关键字模糊搜索
          let datasMap = {}
          $(nodeList).each(function (index, item) {
            item.isSearchNode = true
            datasMap[item['id']] = item
          })
          if (_this.options.searchShowParent) {
            $(nodeList).each(function (index, node) {
              _this.loadParents(node, datasMap)
            })
          }
          let _zNodes = _.values(datasMap)
          let filterNode = _.filter(_zNodes, function (o) {
            return o.level != '0'
          })
          _zNodes = _.orderBy(filterNode, ['sale'], ['desc'])
          _this.initSearchTree(_zNodes, searchWord, serverSearchData)
        })
      }, 200)
    },
    ifHit(node, keyWord, serverSearchData) {
      serverSearchData = serverSearchData || []
      let _this = this
      if (
        _this.options.searchKeys instanceof Array &&
        _this.options.searchKeys.length > 0
      ) {
        let flag = false
        $(_this.options.searchKeys).each(function (index, item) {
          if (item.startsWith('like_')) {
            if (node[item.replace('like_', '')].indexOf(keyWord) != -1) {
              flag = true
              return
            }
          } else if (item.startsWith('eq_')) {
            if (node[item.replace('eq_', '')] === keyWord) {
              flag = true
              return
            }
          }
        })
        return flag
      } else {
        return node[_this.setting.data.key.name_old_name]
          ? node[_this.setting.data.key.name_old_name]
              .toLowerCase()
              .indexOf(keyWord.toLowerCase()) != -1 ||
              _.includes(serverSearchData, node.id)
          : node[_this.setting.data.key.name]
              .toLowerCase()
              .indexOf(keyWord.toLowerCase()) != -1 ||
              _.includes(serverSearchData, node.id)
        // return node[_this.setting.data.key.name].indexOf(keyWord) != -1 || _.includes(serverSearchData, node.id);
      }
    },
    loadParents(node, datasMap) {
      let parent = node.getParentNode()
      if (parent) {
        let copyparent = $.extend({}, parent)
        copyparent.children = null
        copyparent.open = true
        datasMap[parent['id']] = copyparent
        this.loadParents(parent, datasMap)
      } else {
        return
      }
    },
    initSearchTree(data) {
      let _this = this
      this.searchCatTreeObj = $.fn.zTree.init(
        $('#searchCatTree'),
        _this.searchSetting,
        data
      )
    },
    treeSearchOnCheck(event, treeId, treeNode) {
      const node = this.catTreeObj.getNodeByParam('id', treeNode.id)
      this.catTreeObj.checkNode(node, treeNode.checked, true)
      this.treeSelectedData = []
      let ignoreIds = []
      this.catTreeObj.getCheckedNodes().forEach((item) => {
        const { path, cid_path } = this.computeNodePath(item)
        const catInfo = {
          cat_name: item.label,
          cat_id: item.id,
          is_parent: item.is_parent,
          path,
          cid_path,
        }
        // 该节点被全选且父节点未被选中,则子节点id不传入
        if (item.check_Child_State == 2 && ignoreIds.indexOf(item.id) == -1) {
          this.treeSelectedData.push(catInfo)
          ignoreIds.push(...this.getChdNodesIds(item))
        } // 父节点不是全选,子节点没有children
        else if (
          item.check_Child_State == -1 &&
          ignoreIds.indexOf(item.id) == -1
        ) {
          this.treeSelectedData.push(catInfo)
        }
      })
      this.catTreeObj.selectNode(treeNode, true, false)
      this.topSearchCheckedNodes(event, treeId, treeNode)
    },
    topSearchCheckedNodes(event, treeId, treeNode) {
      treeNode.getPath().forEach((node) => {
        this.topNode(event, treeId, node)
      })
      const catTreeObj1 = $.fn.zTree.getZTreeObj('catTree')
      const _treeNode = catTreeObj1.getNodeByParam('id', treeNode.id)
      this.topCheckedNodes(event, 'catTree', _treeNode)
      const catTreeObj2 = $.fn.zTree.getZTreeObj(treeId)
      catTreeObj2.selectNode(treeNode, true, false)
    },
  },
  created() {},
  mounted() {
    this.$emit('mounted-event')
    this.initPanel()
    document.addEventListener('click', this.handleDocumentClick)
  },
  beforeDestroy() {
    this.showKeyInspect = false
    document.removeEventListener('click', this.handleDocumentClick)
  },
  watch: {
    params: {
      handler(newVal, oldVal) {
        this.brand = newVal.brand
        this.title = newVal.title
        this.currentPlat = newVal.plat
      },
      immediate: true,
    },
  },
}
</script>

<style lang="less" scoped>
.switchCatTree {
  margin-top: 20px;
  color: #808080;
}
.allCatTreeText {
  margin-top: 20px;
  color: #808080;
  display: flex;
  justify-content: space-between;
}
.underline {
  display: inline-block;
  text-decoration: underline;
  cursor: pointer;
  padding-bottom: 2px;
}

.keyWordPopover {
  .keyWordPopover_content {
    padding: 10px;
    position: relative;
    .el-switch {
      vertical-align: bottom;
    }
    .el-icon-close {
      position: absolute;
      right: -4px;
      top: -4px;
      cursor: pointer;
    }
  }
}

.title-sub-desc {
  padding-left: 109px;
  margin-top: -10px;
  color: #808080;
}
</style>
<style lang="less">
.cattree-reason {
  padding: 20px !important;
  font-size: 14px;
  width: 390px !important;
  .select-reason-title {
    color: #7eb6ff;
    margin-bottom: 5px;
    font-weight: bold;
  }
  .select-reason-content {
    margin-bottom: 20px;
  }
  .select-sample-title {
    color: #7eb6ff;
    margin-bottom: 5px;
    font-weight: bold;
  }
}
.cat-block-title {
  // width: 420px;
  margin-bottom: 5px;
  .cat-title-desc {
    display: block;
    color: #808080;
  }
}
input.is_error {
  background-color: #ff000010;
  border: 1px solid #ff0000 !important;
  color: #ff0000 !important;
}
.is_loading {
  opacity: 0.5; /* 增加透明度 */
  pointer-events: none; /* 鼠标不可点击 */
}
</style>
